const SET_APP_JSON = 'SET_APP_JSON';
const SET_INDEX_JSON = 'SET_INDEX_JSON';
const SET_COOKIE_JSON = 'SET_COOKIE_JSON';
const SET_IS_PREVIEW = 'SET_IS_PREVIEW';
const SET_IS_MYAPP = 'SET_IS_MYAPP';
const SET_WX_JS_URL = 'SET_WX_JS_URL';
const SET_IS_MINIPROGRAM = 'SET_IS_MINIPROGRAM'
const CLEAR_ALL = 'CLEAR_ALL'
const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS';
import  commonHelper from '../helpers/commonHelper'
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        appJson:{},             //应用Json
        indexJson: {},          //首页JSON
        userInfo:{},            //用户信息
        isMyApp: false,
        isPreview:false,
        jsUrl:"",
        isMiniProgram: false, // 微信小程序||支付宝小程序打开
        isLoginReady: false, // 登录状态
    },
    mutations: {
        [SET_APP_JSON]:function(state, appJson){
            sessionStorage.setItem("appJson",JSON.stringify(appJson));
            state.appJson = appJson;
        },
        [SET_INDEX_JSON](state, indexJson) {
          if(indexJson.startTime){
            indexJson.startTime = commonHelper.formatDate(indexJson.startTime);
          }
          if(indexJson.endTime){
            indexJson.endTime = commonHelper.formatDate(indexJson.endTime);
          }
          if(indexJson.actStartTime){
            indexJson.actStartTime = commonHelper.formatDate(indexJson.actStartTime);
          }
          if(indexJson.actEndTime){
            indexJson.actEndTime = commonHelper.formatDate(indexJson.actEndTime);
          }
          if(indexJson.ckStartTime){
            indexJson.ckStartTime = commonHelper.formatDate(indexJson.ckStartTime);
          }
          if(indexJson.ckEndTime){
            indexJson.ckEndTime = commonHelper.formatDate(indexJson.ckEndTime);
          }
            state.indexJson = indexJson;
        },
        [SET_COOKIE_JSON](state, cookieJson) {
            state.userInfo = cookieJson;
        },
        [SET_IS_PREVIEW](state,preview){
            state.isPreview = preview;
        },
        [SET_IS_MYAPP](state, isMyApp) {
            state.isMyApp = isMyApp;
            if(location.href.includes('activity.szjiyun.com')){
              console.log('冀时办-判断支付宝小程序||微信小程序',commonHelper.isAlipayMiniProgram(),commonHelper.isWechatMiniProgram())
              state.isMyApp = isMyApp || commonHelper.isAlipayMiniProgram() || commonHelper.isWechatMiniProgram()
            }
        },
        [SET_WX_JS_URL](state,url){
            state.jsUrl = url;
        },
        [SET_IS_MINIPROGRAM](state ,isMiniProgram) {
            state.isMiniProgram = isMiniProgram
        },
        [CLEAR_ALL](state) {
            sessionStorage.removeItem("appJson")
            state.indexJson = {}
            state.appJson = {}
        },
        SET_LOGIN_READY(state, status) {
          state.isLoginReady = status
        },
        [SET_LOGIN_STATUS](state, status) {
          if (!state.indexJson) {
            state.indexJson = {};
          }
          state.indexJson.loginStatus = status;
        },
    },
    getters: {
        getIsMyApp: state => {
            return state.isMyApp
        },
        getAppJson: state => {
            let appJson = sessionStorage.getItem("appJson");
            state.appJson = appJson ? JSON.parse(appJson) : {};
            return state.appJson
        },
        getIsMiniProgram: state => {
            return state.isMiniProgram
        }
    },
    actions: {}
  });




// WEBPACK FOOTER //
// ./src/store/index.js